import styled from 'styled-components';

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const NoTagsSelectedAlert = styled.div`
  display: flex;
  padding: 12px 16px;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  border-radius: 16px;
  background: ${({ theme }) => theme.colors.purple1};
`;

export const SubmitButtonsWrapper = styled.div`
  display: flex;
  padding: 24px;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid ${({ theme }) => theme.colors.black2};
`;

export const ScheduledInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  .ant-typography {
    margin: 0;
  }
`;
